/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, Fragment, useEffect, useState} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../../_metronic/layout/core'
import Pagination from 'react-bootstrap/Pagination'
import {Link, useNavigate, useParams} from 'react-router-dom'
import JobServices from '../../../../../services/job'
import UserServices from '../../../../../services/user'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import {toast} from 'react-toastify'
import HTMLRenderer from 'react-html-renderer'
import {Badge, Dropdown, Form, Modal, Row} from 'react-bootstrap'
import Contains from 'utils/helpers/Contains'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const ApplicantsPage: FC = () => {
  let navigate = useNavigate()
  let params = useParams()
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState(1)
  const [statusFilter, setStatusFilter] = useState<any>([0, 3])
  const [previousStatus, setPreviousStatus] = useState<any>('')
  const [mssg, setMssg] = useState('')
  const [modalMssg, setModalMssg] = useState(false)
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [query, setQuery] = useState('')

  const [job, setJob] = useState<any>(null)
  useEffect(() => {
    applicant(statusFilter)
  }, [])

  useEffect(() => {
    applicant({
      status: typeof statusFilter === 'number' ? [statusFilter] : statusFilter,
      previous_status: [previousStatus],
      per_page: pagination.per_page,
      page: pagination.page,
    })
  }, [statusFilter, previousStatus])

  const applicant = async ({...parameter}) => {
    try {
      setJob(null)
      const resp: any = await JobServices.myJobApplicant(params?.jobId, {
        ...parameter,
      })
      setJob(resp.data)
    } catch (error) {
    }
  }

  useEffect(() => {
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      newTotal.push(total + 1)
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })

    applicant({
      status: typeof statusFilter === 'number' ? [statusFilter] : statusFilter,
      previous_status: [previousStatus],
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const handleExport = async () => {
    try {
      const response: any = await JobServices.myJobApplicantExport(params?.jobId)
      const {file, name} = response.data
      var a = document.createElement('a')
      a.href = file
      a.download = name
      document.body.appendChild(a)
      a.click()
      a.remove()
    } catch (error) {
    }
  }

  const handleProccess = async (id: any, status: any, mssg: any) => {
    if (mssg === 'bulk') {
      return await JobServices.updateApplicantStatus({id: id, status: status}).then(() => {
        toast.success('Status pelamar berhasil diubah')
        applicant(statusFilter)
      })
    }

    if (window.confirm(mssg)) {
      await JobServices.updateApplicantStatus({id: id, status: status}).then(() => {
        toast.success('Status pelamar berhasil diubah')
        applicant(statusFilter)
      })
    }
  }

  const handleCheck = (id: any) => {
    let newSelected = selected

    if (id === 'all') {
      if (newSelected.length > 0) {
        newSelected = []
      } else {
        job?.data?.forEach((item: any) => {
          newSelected.push(item.id_hash)
        })
      }
    } else {
      const check = newSelected?.filter((item: any) => item == id)
      if (check?.length > 0) {
        newSelected = newSelected?.filter((item: any) => item != id)
      } else {
        newSelected.push(id)
      }
    }
    setSelected(newSelected)
    setCounter((val) => val + 1)
  }

  const handleBulkApprove = () => {
    selected?.map((item: any) => {
      handleProccess(item, statusFilter?.toString() == '0,3' ? 1 : 2, 'bulk')
    })
  }

  const handleCloseJob = async () => {
    if (window.confirm('Semua pelamar tersisa akan otomatis ditolak?')) {
      await JobServices.closeJob({status: 3, id: params.jobId}).then(() => {
        toast.success('Lowongan berhasil ditutup.')
        navigate('/list-job')
      })
    }
  }

  const toggleMssg = () => setModalMssg(!modalMssg)

  const downloadResume = async (id: string) => {
    const response: any = await UserServices.downloadResume(id)
    const {file, name} = response.data
    var a = document.createElement('a')
    a.href = file
    a.download = name
    document.body.appendChild(a)
    a.click()
    a.remove()
  }

  const PageComponent = () => {
    return (
      <Fragment>
        {Contains('company Company', [localStorage.getItem('role')]) ? (
          <PageTitle
            breadcrumbs={[
              {
                title: 'Dashboard',
                path: '/dashboard',
                isSeparator: false,
                isActive: false,
              },
              {
                title: '/',
                path: '',
                isSeparator: false,
                isActive: false,
              },
              {
                title: 'Semua Lowongan Saya',
                path: '/list-job',
                isSeparator: false,
                isActive: false,
              },
              {
                title: '/',
                path: '',
                isSeparator: false,
                isActive: false,
              },
            ]}
          >
            {job?.data?.length > 0
              ? `${job?.data[0]?.company_job?.company_jobs_title}`
              : 'Pelamar Baru'}
          </PageTitle>
        ) : (
          <Button onClick={() => navigate(-1)} className='btn-sm mb-8' style={{padding: '4px'}}>
            <i className='bi bi-arrow-left fs-1'></i>
          </Button>
        )}
        <div className='col-md-12'>
          {selected?.length > 0 && statusFilter != 2 && (
            <Fragment>
              <Button
                className='btn-sm btn-success mt-8 mb-8'
                onClick={() => {
                  if (
                    window.confirm(
                      statusFilter == 0 ? 'Proses Pelamar Terpilih ?' : 'Recruit Pelamar Terpilih'
                    )
                  ) {
                    handleBulkApprove()
                  }
                }}
              >
                {statusFilter?.toString() == '0,3' && 'Proses Pelamar Terpilih'}
                {statusFilter?.toString() == '1,3' && 'Recruit Data Terpilih'}
              </Button>
            </Fragment>
          )}
          <Modal show={modalMssg} onHide={toggleMssg} size='lg'>
            <Modal.Header closeButton>
              <Modal.Title> Pesan Lamaran</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <HTMLRenderer html={mssg} />
            </Modal.Body>
            <Modal.Footer>
              <Button className='btn-sm' onClick={toggleMssg}>
                Tutup
              </Button>
            </Modal.Footer>
          </Modal>
          <Table responsive className='table-striped align-middle'>
            <thead>
              <tr>
                <th>
                  <Form.Check
                    onClick={() => handleCheck('all')}
                    checked={job?.data?.length === selected.length}
                  />
                </th>
                <th>Nama Pelamar</th>
                <th>Tanggal Melamar</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {counter && job?.data?.length > 0 ? (
                job?.data?.map((item: any, key: any) => {
                  const param = {
                    id: item.id_hash,
                    status: 1,
                  }
                  return (
                    <tr key={key}>
                      <td>
                        <Form.Check
                          onClick={() => handleCheck(item?.id_hash)}
                          checked={
                            selected.filter((f: any) => f === item.id_hash)?.length > 0
                              ? true
                              : false
                          }
                        />
                      </td>
                      <td>
                        <Link
                          to={`/crafted/pages/profile/basic-overview?alumni=${item?.user?.id_hash}`}
                        >
                          {item?.user?.fullname}{' '}
                        </Link>
                        {item?.job_applies_description && (
                          <Badge
                            bg='primary'
                            className='ml-4'
                            style={{marginLeft: '10px'}}
                            onClick={() => {
                              setMssg(item?.job_applies_description)
                              toggleMssg()
                            }}
                          >
                            <span className={`bi bi-envelope`}></span>
                          </Badge>
                        )}
                      </td>
                      <td>{new Date(item?.created_at).toLocaleString()}</td>
                      <td>
                        {item.status == 0 && (
                          <Button className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'>
                            Applied
                          </Button>
                        )}
                        {item.status == 1 && (
                          <Button className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'>
                            In Process
                          </Button>
                        )}
                        {item.status == 2 && (
                          <Button className='shadow-none btn-sm btn-sm btn-outline btn-outline-success'>
                            Recruited
                          </Button>
                        )}

                        {item.status == 3 && (
                          <Button className='shadow-none btn-sm btn-sm btn-outline btn-outline-danger'>
                            Rejected
                          </Button>
                        )}
                      </td>
                      <td>
                        {statusFilter?.toString()?.includes([1, 3]) ? (
                          <Dropdown>
                            <Dropdown.Toggle id='dropdown-basic' className='btn btn-primary btn-sm'>
                              {'  '}
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() =>
                                  navigate(
                                    `/crafted/pages/profile/basic-overview?alumni=${item?.user?.id_hash}`
                                  )
                                }
                              >
                                Lihat
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => downloadResume(item?.user?.id_hash)}>
                                Download PDF{' '}
                              </Dropdown.Item>
                              <Fragment>
                                <Dropdown.Item
                                  onClick={() =>
                                    handleProccess(item.id_hash, 2, 'Terima Pelamar Ini ?')
                                  }
                                >
                                  Terima
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    handleProccess(item.id_hash, 3, 'Tolak Pelamar Ini ?')
                                  }
                                >
                                  Tolak
                                </Dropdown.Item>
                              </Fragment>
                            </Dropdown.Menu>
                          </Dropdown>
                        ) : (
                          <Dropdown>
                            <Dropdown.Toggle id='dropdown-basic' className='btn btn-primary btn-sm'>
                              {'  '}
                              Aksi
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() =>
                                  navigate(
                                    `/crafted/pages/profile/basic-overview?alumni=${item?.user?.id_hash}`
                                  )
                                }
                              >
                                Lihat
                              </Dropdown.Item>
                              <Dropdown.Item onClick={() => downloadResume(item?.user?.id_hash)}>
                                Download PDF{' '}
                              </Dropdown.Item>
                              {statusFilter != 2 && (
                                <Fragment>
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleProccess(param.id, 1, 'Proses Pelamar Ini ?')
                                    }
                                  >
                                    Proses
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleProccess(item.id_hash, 3, 'Tolak Pelamar Ini ?')
                                    }
                                  >
                                    Tolak
                                  </Dropdown.Item>
                                </Fragment>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        )}
                      </td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={6} style={{textAlign: 'center'}}>
                    Tidak ada data
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className='col-md-12'>
          <div style={{float: 'right'}}>
            <Pagination>
              {generateTotalPage(job?.last_page)?.map((item: any) => {
                return (
                  <Pagination.Item
                    key={item}
                    active={item === pagination.page}
                    onClick={() => onChangePerPage(pagination.per_page, item)}
                  >
                    {item}
                  </Pagination.Item>
                )
              })}
            </Pagination>
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <>
      <div className='row'>
        <div className='col-md-12'>
          <div className='card-custom d-grid gap-10'>
            <Row>
              <div className='col-md-9'>
                <Button
                  className='btn btn-sm me-1'
                  type='button'
                  onClick={() => navigate('/list-job')}
                >
                  Kembali
                </Button>
                <Button
                  className='btn btn-success btn-sm me-1'
                  type='button'
                  onClick={() => handleExport()}
                >
                  Excel
                </Button>
                {statusFilter == 2 && (
                  <Button
                    className='btn btn-secondary btn-sm'
                    type='button'
                    onClick={handleCloseJob}
                  >
                    Tutup Lowongan
                  </Button>
                )}
              </div>
            </Row>
            <Tabs>
              <TabList>
                <Tab
                  onClick={() => {
                    setSelected([])
                    setStatusFilter([0, 3])
                    setPreviousStatus('')
                  }}
                >
                  Applied
                </Tab>
                <Tab
                  onClick={() => {
                    setSelected([])
                    setStatusFilter([1, 3])
                    setPreviousStatus(0)
                  }}
                >
                  In Process
                </Tab>
                <Tab
                  onClick={() => {
                    setSelected([])
                    setStatusFilter(2)
                    setPreviousStatus(1)
                  }}
                >
                  Recruited
                </Tab>
                {/* <Tab onClick={() => setStatusFilter(3)}>Rejected</Tab> */}
              </TabList>
              <TabPanel>{PageComponent()}</TabPanel>
              <TabPanel>{PageComponent()}</TabPanel>
              <TabPanel>{PageComponent()}</TabPanel>
              {/* <TabPanel>{PageComponent()}</TabPanel> */}
            </Tabs>
          </div>
        </div>
      </div>
    </>
  )
}

const Applicants: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
          {
            title: 'Semua Lowongan Saya',
            path: '/list-job',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Pelamar Baru
      </PageTitle>
      <ApplicantsPage />
    </>
  )
}

export default Applicants
